
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19 19"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","d":"M-1-1h21v21H-1z"}}),_c('path',{attrs:{"d":"M.148.074l18.389 18.537M18.704 0L0 18.704","stroke":"#fff","stroke-linecap":"undefined","stroke-linejoin":"undefined","fill":"none"}})])
          )
        }
      }
    